<template>
<div class="seccoes">
  <ul class="accordion" 
    data-accordion data-multi-expand="true" 
    id="bolsaseccoes" 
    data-allow-all-closed="true">
    <li class="accordion-item" 
      :class="{ 'is-active': isExpanded(inx) }"
      data-accordion-item 
      v-for="(seccao, inx) in bolsa.Seccoes">
        <a href="#" class="accordion-title"
          @click.prevent="toggleAccordion(inx)">
          {{ seccao.bolsasas_seccoes_titulo }}
        </a>
        <div class="accordion-content" data-tab-content :id="`item${inx}`">
          <span v-html="seccao.bolsasas_seccoes_conteudo"></span>
        </div>
    </li>
  </ul>
</div>
</template>

<script>
import $ from 'jquery';
import 'foundation-sites';
import { ref, onMounted, nextTick } from "vue";

export default {
  props:["bolsa"],
  setup() {

    const expandedItems = ref([]);

    const toggleAccordion = (index) => {
      const selector = `#item${index}`;
      const $content = $(selector);
      const position = expandedItems.value.indexOf(index);
      if (position > -1) {
        expandedItems.value.splice(position, 1);
        $content.slideUp(() => { });
      } else {
        //expandedItems.value.push(index);
        //$content.slideDown(() => { });
      }
    };

    const isExpanded = (index) => expandedItems.value.includes(index);

    onMounted(()=> {
      nextTick(() => {
        const accord = $(".seccoes");
        $(accord).foundation();
        new Foundation.Equalizer($('.seccoes'));
      })
    })

    return {
      isExpanded,
      toggleAccordion
    }
  }
}
</script>

<style lang="scss" scoped>
.accordion-content {
  background-color: transparent;
  border: transparent;
}

.accordion-content p {
  font-family: "PT Sans";
  color: #656565;
  line-height: 2;
  padding-left: 12px;
}

.accordion-title:before {
  font-size: 25px;
  margin-top: -19px;
}

#bolsaseccoes .accordion-title {
  border: transparent;
  color: #4d5354;
  line-height: 1.5;
  padding: 13px 70px 13px 0px;
  border: transparent;
  border-bottom: 1px solid #767979;
  font-family: "Montserrat Bold";
  font-size: 18px;
}


@media (max-width:767px) {
  #bolsaseccoes .accordion-title {
    font-size: 14px;
    padding-top: 11px !important;
    padding-bottom: 11px !important;
    padding-left: 0 !important;
  }
}

.accordion-title:hover,
.accordion-title:focus {
  background-color: transparent;
  color: #707475;
}

.accordion-item.is-active .accordion-content {
  border-bottom: transparent;
}

.accordion-content span :deep(p){
  font-family: "PT Sans";
  color: #656565;
  line-height: 2;
  padding-left: 12px;
}

/*@media (max-width: 676px) {*/
@media (max-width: 767px) {

  .accordion-content span :deep(p) {
    font-size: 14px;
    line-height: 1.9;
    padding-left: 0;
  }

  .accordion-title {
    margin-left: 0;
    padding-top: 6px;
    padding-bottom: 6px;
    font-size: 14px;
    padding-right: 50px;
    line-height: 1.4;
    background-color: transparent;
  }

  .accordion-title:before {
    right: 5px;
  }

  .accordion-item{
    background-color: white;
  }

  .accordion-content {
    border: transparent;
    padding-right: 0;
    padding-left: 0;
    background-color: transparent;
  }

  .accordion-content p {
    font-size: 14px;
    line-height: 1.9;
    padding-left: 0;
  }
}
</style>